// Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';
// modules
import { PurchaseOrder } from 'src/app/modules/purchase-orders/models';

@Component({
    selector: 'app-open-purchase-order-overview',
    templateUrl: './open-purchase-order-overview.component.html',
    styleUrls: ['./open-purchase-order-overview.component.scss'],
    standalone: false
})
export class OpenPurchaseOrderOverviewComponent {
    @Input() purchaseOrders: PurchaseOrder[] = [];

    @Output() openClicked: EventEmitter<number> = new EventEmitter<number>();

    onOpenClicked(id: number): void {
        this.openClicked.emit(id);
    }
}
